import Button from 'antd/lib/button';
import Model from 'antd/lib/modal';
import Row from 'antd/lib/row';
import React from 'react';

function ViewProductModel({ isOpen, product, handleViewModelCloseClick }) {
  return (
    <div>
      <Model
        open={isOpen}
        onCancel={handleViewModelCloseClick}
        closable={false}
        footer={null}
      >
        <div className='px-8 pb-6'>
          <div className='flex items-center justify-between mb-6'>
            <div className='flex items-center gap-3'>
              <div className='p-2 rounded-lg shadow bg-gradient-to-r from-blue-500 to-purple-600'></div>
              <h2 className='text-2xl font-bold text-text m-0'>
                Product Details
              </h2>
            </div>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
            {product?.productImages?.length ? (
              <div className='bg-surface border border-border rounded-lg p-4 shadow-sm md:col-span-2'>
                <div className='text-muted text-xs mb-2'>Images</div>
                <div className='flex flex-wrap gap-3'>
                  {product.productImages.map((item) => (
                    <img
                      key={item.productImageId}
                      src={item.imagePath}
                      alt={`image_${item.productImageId}`}
                      className='w-24 h-24 object-contain border border-border rounded-md bg-white'
                    />
                  ))}
                </div>
              </div>
            ) : null}

            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>Model Number</div>
              <div className='text-text font-semibold'>{product.modelNo}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>Product Name</div>
              <div className='text-text'>{product.productName}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>
                Product Category Name
              </div>
              <div className='text-text'>{product.productCategoryName}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>Weight</div>
              <div className='text-text'>{product.weight}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>GST</div>
              <div className='text-text'>{product.gstTax}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>Body Material</div>
              <div className='text-text'>{product.bodyMaterial}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm md:col-span-2'>
              <div className='text-muted text-xs mb-1'>Description</div>
              <div className='text-text'>{product.description}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm md:col-span-2'>
              <div className='text-muted text-xs mb-2'>Prices</div>
              <div className='grid grid-cols-2 md:grid-cols-4 gap-3'>
                <div className='bg-bg rounded-md px-3 py-2'>
                  <span className='text-muted text-xs'>P1</span>
                  <div className='text-text font-semibold'>{product.p1}</div>
                </div>
                <div className='bg-bg rounded-md px-3 py-2'>
                  <span className='text-muted text-xs'>P2</span>
                  <div className='text-text font-semibold'>{product.p2}</div>
                </div>
                <div className='bg-bg rounded-md px-3 py-2'>
                  <span className='text-muted text-xs'>P3</span>
                  <div className='text-text font-semibold'>{product.p3}</div>
                </div>
                <div className='bg-bg rounded-md px-3 py-2'>
                  <span className='text-muted text-xs'>R1</span>
                  <div className='text-text font-semibold'>{product.r1}</div>
                </div>
              </div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm'>
              <div className='text-muted text-xs mb-1'>Stock</div>
              <div className='text-text'>{product.stock}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm md:col-span-2'>
              <div className='text-muted text-xs mb-1'>Attribute</div>
              <div className='text-text break-words'>{product.attribute}</div>
            </div>
            <div className='bg-surface border border-border rounded-lg p-4 shadow-sm md:col-span-2'>
              <div className='text-muted text-xs mb-1'>Youtube Link</div>
              <div className='text-text break-all'>{product.youtubeLink}</div>
            </div>
          </div>

          <div className='flex justify-end gap-3'>
            <Button onClick={handleViewModelCloseClick}>Close</Button>
          </div>
        </div>
      </Model>
    </div>
  );
}

export default ViewProductModel;
